var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BEB84E4F-3DC0-4516-8016-58D689B42BF0@1,5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.000371365715,2.22375475 C0.000507753438,2.21975206 0.000676207178,2.21574915 0.000876797869,2.21174642 L0,2.25 C0,1.01078644 1.01078644,0 2.25,0 L14.25,0 C15.4892136,0 16.5,1.01078644 16.5,2.25 L16.5,11.25 C16.5,12.4892136 15.4892136,13.5 14.25,13.5 L2.25,13.5 C1.01078644,13.5 0,12.4892136 0,11.25 Z M15,3.69 L8.68009676,8.11442394 C8.42185664,8.29519202 8.07814336,8.29519202 7.81990324,8.11442394 L1.5,3.691 L1.5,11.25 C1.5,11.6607864 1.83921356,12 2.25,12 L14.25,12 C14.6607864,12 15,11.6607864 15,11.25 L15,3.69 Z M14.25,1.5 L2.25,1.5 C1.95882954,1.5 1.70361835,1.67042592 1.57967804,1.91596615 L8.25,6.58450833 L14.920322,1.91596615 C14.7963817,1.67042592 14.5411705,1.5 14.25,1.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Contact",
    transform: "translate(-54.000000, -1054.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-3",
    transform: "translate(20.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/user-Copy-8",
    transform: "translate(34.750064, 96.250000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "FFF",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.0ad3ada261c79de6b5f039895f3d28b6.svg";
export { ForwardRef as ReactComponent };